
import {orderBy} from 'lodash';

export const getSelectedPlacement = state =>
  state.placementDrawer.selectedPlacement;

export const getPlacementNotes = state =>
  orderBy(state.placementDrawer.notes, ['updatedAt'], ['desc']);
